export const API_GW_URL = 'https://geoops.meo.pt/app';
export const API_GW_URL_SSE = 'https://geoops.meo.pt/notification';
//export const API_GW_URL = "https://outapigw.ff.int.meo.pt";